import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';

const styles = theme => ({
    small: {
        width: '32px',
        height: '32px',
        textTransform: 'uppercase',
    },
    normal: {
        width: '64px',
        height: '64px',
        textTransform: 'uppercase',
    },
    big: {
        width: '128px',
        height: '128px',
        fontSize: 64,
        textTransform: 'uppercase',
    },
});

const Small = ({ classes, name, alt, src, color = 'bdbdbd' }) => (
    <Avatar
        className={classes.small}
        src={src}
        style={{ backgroundColor: !src ? `#${color}` : 'transparent' }}
        alt={alt || name}
    >
        {name.substr(0, 1)}
    </Avatar>
);

const Normal = ({ classes, name, alt, src, color = 'bdbdbd' }) => (
    <Avatar
        className={classes.normal}
        src={src}
        style={{ backgroundColor: !src ? `#${color}` : 'transparent' }}
        alt={alt || name}
    >
        {name.substr(0, 1)}
    </Avatar>
);
const Big = ({ classes, name, alt, src, color = 'bdbdbd' }) => (
    <Avatar
        className={classes.medium}
        src={src}
        style={{ backgroundColor: !src ? `#${color}` : 'transparent' }}
        alt={alt || name}
    >
        {name.substr(0, 1)}
    </Avatar>
);

export default {
    Small: withStyles(styles)(Small),
    Normal: withStyles(styles)(Normal),
    Big: withStyles(styles)(Big),
};
